import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useBrand } from "../../context/BrandContext";
import { fetchTacticalLibrary, schemaLabel } from "../../components/funtionsBD/tacticalPatternService";
import "./TacticalPatternLibrary.css";

export function TacticalPatternLibrary() {
  const { t, i18n } = useTranslation();
  const { themeMode } = useBrand();
  const mode = themeMode === "light" ? "light" : "dark";
  const navigate = useNavigate();
  const lang = (i18n.language || "en").slice(0, 2);
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetchTacticalLibrary()
      .then((data) => {
        if (!cancelled) setRows(data?.patterns || []);
      })
      .catch((err) => {
        if (!cancelled) setError(err?.message || t("error"));
      });
    return () => {
      cancelled = true;
    };
  }, [t]);

  return (
    <div className={`tpl tpl--${mode}`}>
      <header className="tpl__head">
        <p className="tpl__kicker">{t("schemaLibraryKicker", "CB8 · Schéma de jeu")}</p>
        <h1>{t("schemaLibraryTitle", "Tactical patterns")}</h1>
        <p className="tpl__lede">
          {t(
            "schemaLibraryLede",
            "Train the five championship point-winners and any club custom patterns. Each card shows the recipe description. Readiness uses your autoeval; video verifies the third ball when a clip exists."
          )}
        </p>
        <button
          type="button"
          className="tpl__prep"
          onClick={() => navigate("/tactical/prep")}
        >
          {t("schemaPrepCta", "Prepare an opponent")}
        </button>
      </header>
      {error ? <p className="tpl__err">{error}</p> : null}
      <div className="tpl__grid">
        {rows.map((row) => {
          const ready = row.readiness || {};
          const score = Number(ready.score) || 0;
          return (
            <article key={row.schema_key} className="tpl-card">
              <div className="tpl-card__top">
                <h2>{row.name || schemaLabel(row.schema_key, lang)}</h2>
                <span className={`tpl-pill ${ready.verified ? "is-video" : "is-self"}`}>
                  {row.is_custom
                    ? t("schemaCustom", "Club pattern")
                    : ready.verified
                      ? t("schemaVerified", "Video verified")
                      : t("schemaSelfRated", "Self-rated")}
                </span>
              </div>
              {row.description || row.recipe_description ? (
                <p className="tpl-card__desc">
                  {row.description || row.recipe_description}
                </p>
              ) : null}
              <div className="tpl-bar" aria-label={t("schemaReadiness", "Readiness")}>
                <span style={{ width: `${score}%` }} />
              </div>
              <p className="tpl-card__score">
                {score}/100
                {ready.disagreement ? (
                  <em> · {t("schemaDisagree", "3rd ball not landing")}</em>
                ) : null}
              </p>
              <div className="tpl-card__point" aria-hidden="true">
                <span>{t("schemaServe", "Serve")}</span>
                <span>→</span>
                <span>{t("schemaThird", "3rd")}</span>
                <span>→</span>
                <span>{t("schemaFinish", "Finish")}</span>
              </div>
              <p className="tpl-card__meta">
                {t("schemaSessions", "{{n}} sessions", { n: row.sessions || 0 })}
                {row.last_perf != null ? ` · ${t("schemaLastPerf", "last")} ${row.last_perf}/5` : ""}
              </p>
              {row.drills?.length ? (
                <ul className="tpl-card__drills">
                  {row.drills.map((d) => (
                    <li key={d.ex_id}>{d.name}</li>
                  ))}
                </ul>
              ) : null}
            </article>
          );
        })}
      </div>
      <p className="tpl__foot">
        <Link to="/competition">{t("schemaToCompetition", "Competition")}</Link>
      </p>
    </div>
  );
}

export default TacticalPatternLibrary;
